
import $http from "../utils/$http"
import router from '../router'
const modulesFiles = require.context('./model', true, /\.js$/)
const defaultSetings = require('../../config')
// export const models = {}

export const models = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
  }, {})
export const initMouleServe = (app, modules) => {
       app.config.globalProperties.$api = {}
       app.config.globalProperties.$post = $http.post
       app.config.globalProperties.$get = $http.get
       app.config.globalProperties.$Prouter = router
       app.config.globalProperties.$processEnv = {
           ...process.env,
          ...defaultSetings.env
       }
   
    for (const [key, value] of Object.entries(modules)) {
        // app.config.globalProperties.$api[key] = value
        if( modules[key] && Object.prototype.toString.call(modules[key]) === "[object Object]" && Object.keys(modules[key]).length) {
                  for(const [selfkey, fn] of Object.entries(modules[key])) {
                    if(selfkey && typeof fn === "function") {
                        app.config.globalProperties.$api[selfkey] = fn
                    }
                }
        }
    }

      return {
        $post: app.config.globalProperties.$post,
        $get: app.config.globalProperties.$get,
        $api: app.config.globalProperties.$api,
        $Prouter: app.config.globalProperties.$Prouter,
        $processEnv: app.config.globalProperties.$processEnv
      }
   
}